import React from "react"
import styles from "./styles.scss"

const CompanyInfo = () => (
  <address className={styles.contact}>
    <div className={styles.wrapper}>
      <b className={styles.title}>Kontakt</b>
      <span className={styles.listItem}>
        <a
          className={styles.contactLink}
          href="mailto:info@saits.se"
          title="Mejla oss"
        >
          info@saits.se
        </a>
      </span>
      <span className={styles.listItem}>
        <a
          href="tel:+46722366791"
          className={styles.contactLink}
          title="Ring Rasmus Sandström, VD på SAITS"
        >
          +46 72 236 67 91
        </a>
      </span>
      <span className={styles.listItem}>
        <a
          href="https://goo.gl/maps/3NsqZJPZcJr"
          className={styles.contactLink}
          title="Se SAITS kontor på Google Maps"
        >
          S:t Olofsgatan 35,
          <br />
          753 29 Uppsala
        </a>
      </span>
    </div>
  </address>
)

export default CompanyInfo



// WEBPACK FOOTER //
// ./src/components/Footer/CompanyInfo/index.jsx